import * as React from "react";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
} from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";

/**
 * Right-hand overlay panel with the look of the header's notification and reminder drawers, opened and closed by
 * its parent. It does not block the page behind it, so the screen stays usable while the panel is open.
 */
const ControlledDrawer = ({ open, onClose, title, children, className = "" }) => (
  <OverlayDrawer
    className={`DrawerOverlay ${className}`.trim()}
    modalType="non-modal"
    position="end"
    open={open}
    onOpenChange={(_, data) => {
      if (!data.open) onClose();
    }}
  >
    <DrawerHeader>
      <DrawerHeaderTitle
        action={
          <Button
            appearance="subtle"
            aria-label="Close"
            icon={<Dismiss24Regular />}
            onClick={onClose}
          />
        }
      >
        {title}
      </DrawerHeaderTitle>
    </DrawerHeader>

    <DrawerBody>{children}</DrawerBody>
  </OverlayDrawer>
);

export default ControlledDrawer;
